import React from 'react';
import Overlay from 'components/revelo-ui/content/overlay';

const OverlayTastic = ({ data }) => {
  return <Overlay {...data} />;
};

export default OverlayTastic;
